import { clone } from 'lodash';
import { SessionProfileActionTypes } from '~/actions/session';

const initialState = {
  hasLoaded: false,
  site_name: 'Loading ...',
  seismic: {
    enable: false,
    station: {},
  },
  pressure: {
    enable: false,
    waterStorage: {
      enable: false,
      upperLine: [],
      lowerLine: [],
    },
  },
  seepage: {
    enable: false,
  },
  seepage_v2: {
    enable: false,
  },
  rain: {
    enable: false,
  },
};

export default (state = initialState, action) => {
  const { type, ...param } = action;

  // `action.type`
  switch (type) {
    case SessionProfileActionTypes.LOAD:
      if (Object.prototype.hasOwnProperty.call(param, 'profile')) {
        const {
          profile: {
            pressure: { rain_sensor, ...pressureSensor },
            ...profile
          },
        } = param;

        return clone({
          ...state,
          ...profile,
          hasLoaded: true,
          pressure: pressureSensor,
          rain: {
            enable: rain_sensor !== false,
            dataIndex: rain_sensor !== false && rain_sensor,
          },
        });
      }

      return state;
    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./resources/assets/js/reducers/damProfile.js